import { IConfigurations } from '@epicuro-next/platform/configuration';

export const SITE_SELECTOR_NAMESPACE = 'siteSelector';

/**
 * configuration keys for this module
 */
export enum SiteSelectorConfigurationKeys {
  SitesOrder = 'sites-order',
}

/**
 * Configuration return types and default values for this module
 */
export interface SiteSelectorConfigurations
  extends IConfigurations<SiteSelectorConfigurationKeys> {
  [SiteSelectorConfigurationKeys.SitesOrder]: string[];
}
